import { Control, FieldValues, Path } from 'react-hook-form'
import { IModalProps, Modal } from './Modal'
import { ModalFieldHeaderInput } from './ModalFieldHeaderInput'
import clsx from 'clsx'

export interface ModalWithFieldHeaderProps<T extends FieldValues>
  extends Omit<IModalProps, 'title' | 'description' | 'customHeader'> {
  // Field header configuration
  control: Control<T>
  titleFieldName: Path<T>
  descriptionFieldName: Path<T>
  titlePlaceholder?: string
  descriptionPlaceholder?: string
}

export function ModalWithFieldHeader<T extends FieldValues>({
  control,
  titleFieldName,
  descriptionFieldName,
  titlePlaceholder,
  descriptionPlaceholder,
  headerExtra,
  ...modalProps
}: ModalWithFieldHeaderProps<T>) {
  const customHeader = (
    <div className={clsx('flex flex-col gap-2')}>
      <div className="flex flex-row justify-between items-start gap-4">
        <ModalFieldHeaderInput
          control={control}
          name={titleFieldName}
          placeholder={titlePlaceholder || 'Enter name'}
          type="title"
        />
        {headerExtra}
      </div>

      <ModalFieldHeaderInput
        control={control}
        name={descriptionFieldName}
        placeholder={descriptionPlaceholder || 'Add description (optional)'}
        type="description"
      />
    </div>
  )

  return <Modal {...modalProps} customHeader={customHeader} />
}
